import { render } from "./Directing.vue?vue&type=template&id=bce40078&ts=true"
import script from "./Directing.vue?vue&type=script&lang=ts"
export * from "./Directing.vue?vue&type=script&lang=ts"

import "./Directing.vue?vue&type=style&index=0&id=bce40078&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/DanhGia_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__